<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="返修工时维护"
      width="1000px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="task"
        class="form"
        label-width="110px"
        style="height: 200px;">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型">
            <el-select v-model="task.repairType">
              <el-option label="来料不良" value="来料不良" default/>
              <el-option label="生产不良" value="生产不良"/>
              <el-option label="客户需求" value="客户需求"/>
              <el-option label="其它" value="其它"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工时">
            <el-input v-model="task.repairTime" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="描述">
            <el-input
                v-model="task.repairDesc"
                type="textarea"
                style="min-height: 80px;"
                autosize
                placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: "",
        task: {
          pkId: 0,
          repairType: "来料不良",
          repairDesc: "",
          repairTime: 0,
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.task = row;
        }
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.task.repairTime < 0) {
              this.$confirm("请输入正确工时", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else {
              this.submitLoading = true;
              this.$http
                .post("basic", "taskDispatchBills/updateRepairTime", this.task)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                    this.dialogVisible = false;
                  } else {
                    this.$message.error(resp.message);
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },

    },
  };
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
